


export default function Loading({ color, width }) {
	return (
		<div className="relative" style={{ width: `${width}px`, height: `${width}px` }}>
			<div className="absolute top-[0] left-[0] rounded-[100px] opacity-[40%]"
				style={{ width: `${width}px`, height: `${width}px`, border: `${width / 4}px solid ${color}` }}>
			</div>
			<div className="absolute rounded-[100px] animate-spin"
				style={{ width: `${width}px`, height: `${width}px`, borderColor: 'transparent', borderWidth: `${width / 4}px`, borderTop: `${width / 4}px solid ${color}` }}>
			</div>
		</div>
	);
}
